import { appI18n } from "@/services/culture/i18n";

const DEFAULT_PLATFORM_NAME = "Capture";

type MatchWithStaticTitle = {
  staticData?: {
    title?: string;
  };
};

const getPageTitleFromMatches = (matches: MatchWithStaticTitle[]) => {
  const seen = new Set<string>();
  const titleParts: string[] = [];

  for (let index = matches.length - 1; index >= 0; index -= 1) {
    const match = matches[index];
    const title = match?.staticData?.title;
    if (typeof title !== "string") {
      continue;
    }

    const isTranslationKey = title.includes(".");

    let resolvedTitle = title;
    if (isTranslationKey) {
      if (!appI18n.exists(title)) {
        resolvedTitle = "";
      } else {
        resolvedTitle = appI18n.t(title).trim();
      }
    }

    const normalizedTitle = resolvedTitle.trim();
    if (!normalizedTitle || seen.has(normalizedTitle)) {
      continue;
    }

    seen.add(normalizedTitle);
    titleParts.push(normalizedTitle);
  }

  return titleParts.length > 0 ? titleParts.join(" | ") : undefined;
};

export const buildBrandingHead = ({ matches, platformName }: { matches: MatchWithStaticTitle[]; platformName?: string | null }) => {
  const normalizedPlatformName = platformName?.trim() || DEFAULT_PLATFORM_NAME;
  const pageTitle = getPageTitleFromMatches(matches);
  const title = pageTitle ? `${pageTitle} | ${normalizedPlatformName}` : normalizedPlatformName;

  return {
    meta: [{ title }],
  };
};
